export default {
  name: 'home',
  components: {
  },

  data() {
    return {
      step: 1,
      list: [],
      datas: {},
      showMores: true,
      params: {
        orderId: '',
        bid: ''
      },
      code: '',
      localIds: '',
      shows1: false,
      shows: false,
      userInfo: {},
      shows2: true
    }
  },
  created() {
    // console.log('window.location.href===' + window.location.href)
  },
  mounted: function () {
    // this.testLogin();
    if (this.$route.query.code) {
      this.getInfo(this.$route.query.code)
    } else {
      this.apiGet('/h5/api/user/getUserInfo', '', res => {
        if (res.state) {
          this.userInfo = res.data
          if (!res.data.alipay_id) {
            this.$confirm('没有绑定支付宝,请先绑定支付宝', '提示', {
              confirmButtonText: '去绑定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push({ path: '/bindAli' })
            }).catch(() => { })
          }
          this.getDatas()
          sessionStorage.setItem('loginInfo', res.data)
        } else {
          this.$message(res.msg)
        }
      })
    }
    // this.getInfo();
  },
  methods: {
    testLogin(){
      
      this.apiGet('/h5/api/weixin/auth/testLogin', {}, res => {
        if (res.state) {
          sessionStorage.setItem('token', res.data)
          sessionStorage.setItem('loginInfo', JSON.stringify(res.data))
          // window.location.href = '/home'
        } else {
        }
      })
    },
    handlePaste: function () {
      console.log('禁止黏贴')
    },
    toPage: function(url = '/bindAli') {
      this.$router.push({ path: url })
    },
    getInfo: function (code) {
      this.apiGet('/h5/api/weixin/auth', { code: code }, res => {
        if (res.state) {
          sessionStorage.setItem('token', res.data)
          this.apiGet('/h5/api/user/getUserInfo', '', res => {
            if (res.state) {
              this.toPageuserInfo = res.data
              if (!res.data.alipay_id) {
                this.$confirm('没有绑定支付宝,请先绑定支付宝', '提示', {
                  confirmButtonText: '去绑定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.$router.push({ path: '/bindAli' })
                }).catch(() => { })
              }
              sessionStorage.setItem('loginInfo', JSON.stringify(res.data))
              window.location.href = '/taobao/exchange'
            } else {
              // this.$message(res.msg);
            }
          })
        } else {
          // this.$message(res.msg);
        }
      })
    },
    saves: function () {
      if (!this.params.orderId) {
        this.$message('请输入订单号')
        return
      }
      this.params.bid = localStorage.getItem('bid')
      this.apiGet('/h5/api/taobao/exchange/postOrder', this.params, res => {
        if (res.state) {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.resets()
        } else {
          this.$message(res.msg)
        }
      })
    },
    // 复制
    copy(data) {
      let url = data
      let oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success'
      })
      oInput.remove()
    },
    getDatas: function () {
      this.apiGet('/h5/api/taobao/exchange/loadConfig', { bid: localStorage.getItem('bid') || '' }, res => {
        if (res.state) {
          this.datas = res.data
        } else {
          this.$message(res.msg)
        }
      })
    },
    resets: function () {
      this.params.orderId = ''
    }

  }

}



// WEBPACK FOOTER //
// ./src/views/exchange/exchange.js